import React from "react";
import { useContext, useEffect, useState } from "react";
import styles from "./Ussd.module.css";
import { SupportEmail } from "../../common/SupportFooter";
import { Header } from "../../common/Header";
import { AmountSection } from "../../common/AmountSection";
import { RoutingContext } from "../../../context/Router";
import { MobileWrapper } from "../../common/MobileWrapper";
import { Details } from "./Details";
import { listenToTransactionStatus } from "../../../context/utils";
import { BackToMethods } from "../../common/BackToMethods";
import { Processing } from "../../common/Processing";
import { StatusContext } from "../../../context/Status";
import axios from "axios";
import { ErrorAlertContext } from "../../../context/ErrorAlert";
import Loader from "../../common/Loader";
import { StatusMessage } from "../../StatusMessage";
import { UssdContext } from "../../../context/Ussd";

export const UssdMethod = () => {
  const { email, currency, amount, merchantKey, payData } =
    useContext(RoutingContext);
  const { pageTransactionStatus, setPageTransactionStatus } =
    useContext(StatusContext);
  const { onShowAlert } = useContext(ErrorAlertContext);
  const { ussdBankList, ussdDetailsLoading } = useContext(UssdContext);

  const [bankCode, setBankCode] = useState<string>("");
  const [hasBankCode, setHasBankCode] = useState(false);
  const [tabDisplayed, setTabDisplayed] = useState("login");
  const [isLoading, setIsLoading] = useState(ussdDetailsLoading);
  const [transRef, setTransRef] = useState("");
  const getUssdCodeToDial = async (bankOption: any) => {
    setIsLoading(true);
    const bankCode = bankOption.value;
    const { kit } = payData;
    const payStack = payData.kit.paystack
    const payload = {
      tx_ref: kit?.tx_ref,
      account_bank: bankCode,
      amount,
      currency: "NGN",
      email: kit?.email,
      phone_number: kit?.phone_number,
      businessId: kit?.businessId,
      merchantKey: kit?.merchantKey,
      sourceCurrency: kit?.sourceCurrency,
      productType: payData.kit.productType ?? "COLLECTION",
      firstName: kit.firstName,
      lastName: kit.lastName,
      paymentType: payData.kit?.paymentType || 'html-checkout',
      fullname:kit.firstName + " " + kit.lastName,
      rate: kit.rate,
      category: kit.category,
      paylinkToken: payData.kit.paylinkToken,

    };
    const referrerPayLoad = {
        ...payload,
        code: bankCode
    
    }
    let url = '';

    if (payStack) {
        url = `${process.env.REACT_APP_API_URL}pay/v3/NGN/ussd`;
    } else {
        url = `${process.env.REACT_APP_API_URL}pay/v2/NGN/ussd`;
    }

    try {
      const response = await axios(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-auth-token": merchantKey,
            ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
                "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
              })
          },
          data: payStack ? referrerPayLoad : payload,
        }
      );
      const responseData = response.data;
      const { data } = responseData;
      setBankCode(responseData.data.ussdString || data.ussdCode);
      setHasBankCode(true);
      setTransRef(responseData.data.tx_ref);
      listenToTransactionStatus(
        responseData.data.tx_ref,
        setTabDisplayed,
        setPageTransactionStatus
      );

      if (responseData.status === "error") {
        onShowAlert(
          responseData,
          "Payment failed please try again: " + responseData.message
        );
        }
    } catch (err) {
      // @ts-ignore
      onShowAlert(err, err?.response?.data?.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(ussdDetailsLoading);
  }, [ussdDetailsLoading]);

  if (tabDisplayed === "error" || tabDisplayed === "success") {
    return <StatusMessage type={tabDisplayed} />;
  }


  return (
    <MobileWrapper>
      <Loader isLoading={isLoading} />
      <div className={styles.container}>
        <div className={styles.main}>
          <Header email={email} />
          <AmountSection amount={amount} currency={payData?.details?.currency}/>
          <div className={styles.body}>
            {pageTransactionStatus === "idle" && (
              <Details
                bankList={ussdBankList}
                onChange={getUssdCodeToDial}
                bankCode={bankCode}
                hasBankCode={hasBankCode}
                isLoading={isLoading}
              />
            )}
            {pageTransactionStatus === "processing" && (
              <Processing
                transactionRef={transRef}
                setTabDisplayed={setTabDisplayed}
              />
            )}
          </div>
          {pageTransactionStatus !== "processing" && <BackToMethods />}
        </div>
        <SupportEmail />
      </div>
    </MobileWrapper>
  );
};
